import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
render(<BrowserRouter data-id="element-131">
    <App data-id="element-132" />
  </BrowserRouter>, document.getElementById('root'));